import { Input } from '@velocity/ui';
import React from 'react';
import FormFieldShell, { FormFieldShellProps } from './form-field-shell';
import { formatGermanDateInput } from './format-german-date-input';

export interface FormDateFieldProps extends FormFieldShellProps {
  value?: string | null;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  autoComplete?: string;
  dataTestId?: string;
}

/*
 * Velocity `FormField` + `Input` for German dates (TT.MM.JJJJ) with dot
 * auto-formatting. Controlled, meant to be used with react-hook-form's
 * `Controller`; validation stays in the yup schema.
 */
const FormDateField: React.FC<FormDateFieldProps> = ({
  name,
  label,
  value,
  onChange,
  onBlur,
  placeholder = 'TT.MM.JJJJ',
  hideLabel,
  errorMessage,
  hint,
  tooltip,
  required,
  disabled,
  readOnly,
  autoComplete = 'bday',
  dataTestId,
  className,
}) => {
  const currentValue = value ?? '';

  return (
    <FormFieldShell
      {...{
        name,
        label,
        hideLabel,
        errorMessage,
        hint,
        tooltip,
        required,
        disabled,
        readOnly,
        className,
      }}
    >
      <Input
        name={name}
        type='text'
        inputMode='numeric'
        maxLength={10}
        placeholder={placeholder}
        autoComplete={autoComplete}
        value={currentValue}
        onChange={(event) =>
          onChange(formatGermanDateInput(event.target.value, currentValue))
        }
        onBlur={onBlur}
        inputProps={{ 'data-testid': dataTestId ?? `input-date-${name}` }}
      />
    </FormFieldShell>
  );
};

export default FormDateField;
